import m, { redraw } from 'mithril'

//Components
import popup from '../components/popup'
import my_input from '../components/forms/input'
import range_slider from '../components/forms/range_slider'
import Radio from '../components/forms/radio'
import column_adjuster from '../components/authors/column_adjuster'
import my_table from '../components/mytable'
import author_tile from '../components/authors/author_tile'
//Icons
import { tick_icon, up_arrow, down_arrow, tile_icon, list_icon, filter_icon, icons_icon } from '../components/icons'

//Models
import Authors from '../../models/Authors'
import Genres from '../../models/Genres'

//Logics
import { alphabetise, num_compare } from '../../logic/Sorter'
import { capitalise_first } from '../../logic/Formatter'

//Constants
const image_base = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'
const SEARCH_FILTER_DELAY = 500
const DEFAULT_SORT = 'pen_name' //'l_ranking'


const Page = {

    oninit: vnode => {
        vnode.state.display = 'tiles'//'list' 'tiles'
        vnode.state.stage = 'filter'//'search'
        vnode.state.selected_genres = []
        vnode.state.decade_range = { start: 0, end: 100 }
        vnode.state.genre_strategy = 'Any'
        vnode.state.sort_method = all_author_columns.find(c => c.code == DEFAULT_SORT).order
        vnode.state.sort_code = DEFAULT_SORT
        vnode.state.default_enabled_columns = ['pen_name', 'full_name']
        if (screen.width > 700) vnode.state.default_enabled_columns = ['pen_name', 'full_name', 'genres', 'nationality', 'born']
        vnode.state.enabled_columns = vnode.state.default_enabled_columns.slice()

        load_authors(vnode)
    },

    view: function (vnode) {

        repopulate(vnode)

        let sorted_authors = vnode.state.filtered_authors.sort(((a, b) => {
            let winner = vnode.state.sort_method(a, b, vnode.state.sorting_reversed)
            if (vnode.state.sorting_reversed) winner = -winner
            return winner
        }))

        return [

            vnode.state.filter_selection_open ?
                m(filter_selection,
                    {
                        selected_genres: vnode.state.selected_genres,
                        decade_range: vnode.state.decade_range,
                        close: () => vnode.state.filter_selection_open = false,
                        reset: () => {
                            vnode.state.selected_genres = []
                            vnode.state.decade_range = { start: 0, end: 100 }
                            vnode.state.genre_strategy = 'Any'

                            repopulate(vnode)

                        },
                        open_filter: filter => {
                            vnode.state.changing_filter = filter
                        }
                    }
                ) : [],


            m('.page.authors_page',
                m('.search_and_filter',
                    m('.',
                        {
                            class: vnode.state.search_focus ? 'd_computer' : ''
                        },
                        m('h1.default_h1', 'The Authors'),
                        m('h2.default_h2', 'Read from 60+ Authors.'),

                        // m('.separate_top')
                    ),


                    m('.authors_section_a.centre',
                        m('.search_then_filter',
                            {
                                class: vnode.state.search_focus ? 'search_focus' : ''
                            },

                            m(search, {
                                value: vnode.state.searching_text,
                                // focus: vnode.state.stage == 'search',
                                onchange: (search_text) => {
                                    vnode.state.searching_text = search_text

                                    update_search(vnode, search_text)
                                },
                                onfocus: () => {
                                    vnode.state.search_focus = true
                                    //Scroll into view
                                },
                                onfocusout: () => {
                                    vnode.state.search_focus = false
                                    //Scroll into view
                                }
                            }),

                            m(filter_button,
                                {
                                    active: vnode.state.selected_genres.length ||
                                        (vnode.state.decade_range.start != 0 || vnode.state.decade_range.end != 100)
                                    ,
                                    onclick: () => {
                                        vnode.state.filter_selection_open = true
                                    }
                                })

                        ),

                        m('.half_separate'),

                        m('.structure_buttons',
                            m(display_buttons,
                                {
                                    display: vnode.state.display,
                                    onchange: val => vnode.state.display = val
                                }
                            ),

                            m(sort_button, {
                                columns: all_author_columns,
                                sort_code: vnode.state.sort_code,
                                sorting_reversed: vnode.state.sorting_reversed,
                                onchange: e => {
                                    if (vnode.state.sort_code == e.target.value && !vnode.state.sorting_reversed) {
                                        vnode.state.sorting_reversed = true
                                    }
                                    else {
                                        vnode.state.sorting_reversed = false
                                    }
                                    vnode.state.sort_method = all_author_columns.find(c => c.code == e.target.value).order
                                    vnode.state.sort_code = e.target.value
                                },
                                reverse: () => {
                                    vnode.state.sorting_reversed = !vnode.state.sorting_reversed
                                }
                            })
                        )
                    )
                ),

                vnode.state.display == 'list' ? m(author_table,

                    {
                        authors: sorted_authors,
                        change_columns: c => vnode.state.enabled_columns = c.slice(),
                        enabled_columns: vnode.state.enabled_columns,
                        columns: all_author_columns,
                        default_enabled_columns: vnode.state.default_enabled_columns,
                        filter_active_warning: (
                            vnode.state.searching_text &&
                            (
                                vnode.state.selected_genres.length ||
                                (vnode.state.decade_range.start != 0 || vnode.state.decade_range.end != 100))
                        )
                    }) : [],

                (vnode.state.display == 'tiles' || vnode.state.display == 'icons') ? m(Large_tiles, {
                    authors: sorted_authors,
                    sort_method: vnode.state.sort_method,
                    sorting_reversed: vnode.state.sorting_reversed,
                    filter_active_warning: (
                        vnode.state.searching_text &&
                        (
                            vnode.state.selected_genres.length ||
                            (vnode.state.decade_range.start != 0 || vnode.state.decade_range.end != 100)
                        )),
                    icons: vnode.state.display == 'icons'

                }) : [],
            ),


            vnode.state.changing_filter == 'Genres' ? m(Genres_options, {
                selected_genres: vnode.state.selected_genres_changes || vnode.state.selected_genres,
                apply: () => {
                    vnode.state.changing_filter = false
                    if (vnode.state.selected_genres_changes) vnode.state.selected_genres = vnode.state.selected_genres_changes
                    vnode.state.selected_genres_changes = false

                    if (vnode.state.genre_strategy_changes) vnode.state.genre_strategy = vnode.state.genre_strategy_changes
                    vnode.state.genre_strategy_changes = false


                    vnode.state.filter_selection_open = true

                    repopulate(vnode)

                },
                clear: () => {
                    vnode.state.selected_genres_changes = []
                    vnode.state.genre_strategy_changes = 'Any'

                },
                select_all: () => {
                    vnode.state.selected_genres_changes = Genres.list.map(g => capitalise_first(g.code))
                },
                close: () => {
                    vnode.state.changing_filter = false
                    vnode.state.filter_selection_open = true
                    vnode.state.selected_genres_changes = false
                    vnode.state.genre_strategy_changes = false

                },

                onclick: genre => {

                    if (!vnode.state.selected_genres_changes) {
                        vnode.state.selected_genres_changes = vnode.state.selected_genres.slice()
                    }
                    if (vnode.state.selected_genres_changes.includes(genre)) {
                        vnode.state.selected_genres_changes = vnode.state.selected_genres_changes.filter(g => g !== genre)
                    } else {
                        vnode.state.selected_genres_changes.push(genre)
                    }

                },

                strategy: vnode.state.genre_strategy_changes || vnode.state.genre_strategy,
                change_strategy: (strat) => { vnode.state.genre_strategy_changes = strat }

            }
            ) : [],

            vnode.state.changing_filter == 'Decades' ? m(Decades_options, {
                decade_range: vnode.state.decade_range_change || vnode.state.decade_range,
                earlist_decade: vnode.state.earlist_decade,
                latest_decade: vnode.state.latest_decade,
                apply: () => {
                    if (vnode.state.decade_range_change) {
                        vnode.state.decade_range.start = vnode.state.decade_range_change.start
                        vnode.state.decade_range.end = vnode.state.decade_range_change.end
                        vnode.state.decade_range_change = false
                    }
                    vnode.state.filter_selection_open = true
                    vnode.state.changing_filter = false
                },
                clear: () => {
                    vnode.state.decade_range_change = { start: 0, end: 100 }
                },
                close: () => {
                    vnode.state.decade_range_change = false
                    vnode.state.changing_filter = false
                    vnode.state.filter_selection_open = true

                },

                change_max_decade: (percentage_change) => {

                    vnode.state.decade_range = vnode.state.decade_range || { start: 0, end: 100 }
                    if (!vnode.state.decade_range_change) {
                        vnode.state.decade_range_change = {}
                        vnode.state.decade_range_change.start = vnode.state.decade_range.start
                        vnode.state.decade_range_change.end = vnode.state.decade_range.end
                    }

                    vnode.state.decade_range_change.end += percentage_change
                    vnode.state.decade_range_change.end = Math.max(vnode.state.decade_range_change.end, 1)
                    vnode.state.decade_range_change.end = Math.min(vnode.state.decade_range_change.end, 100)
                    vnode.state.decade_range_change.end = Math.max(vnode.state.decade_range_change.end, vnode.state.decade_range_change.start)
                },
                change_min_decade: (percentage_change) => {
                    vnode.state.decade_range = vnode.state.decade_range || { start: 0, end: 100 }
                    if (!vnode.state.decade_range_change) {
                        vnode.state.decade_range_change = {}
                        vnode.state.decade_range_change.start = vnode.state.decade_range.start
                        vnode.state.decade_range_change.end = vnode.state.decade_range.end
                    }

                    vnode.state.decade_range_change.start += percentage_change
                    vnode.state.decade_range_change.start = Math.max(vnode.state.decade_range_change.start, 0)
                    vnode.state.decade_range_change.start = Math.min(vnode.state.decade_range_change.start, 99)
                    vnode.state.decade_range_change.start = Math.min(vnode.state.decade_range_change.end, vnode.state.decade_range_change.start)
                },
                set: (new_range) => {
                    vnode.state.decade_range_change = new_range
                },
            }
            ) : [],
        ]
    }
}


const f_s_toggle = {
    view: vnode => {
        return [
            m('.f_s_toggle.d_flex.d_even',
                m(Radio, {
                    text: 'Filter',
                    active: vnode.attrs.val == 'filter',
                    onclick: () => {
                        vnode.attrs.onchange('filter')
                    }
                }),
                m(Radio, {
                    text: 'Search',
                    active: vnode.attrs.val == 'search',
                    onclick: () => {
                        vnode.attrs.onchange('search')
                    }
                })
            )
        ]
    }
}


const search = {
    view: vnode => [


        m('.search_bar',
            m(my_input,
                {
                    id: 'author_search',
                    value: vnode.attrs.value,
                    search: true,
                    class: 'absolute_centre',
                    placeholder: 'Search',
                    onfocus: () => vnode.attrs.onfocus(),
                    onfocusout: () => vnode.attrs.onfocusout(),

                    onchange: (search_text) => vnode.attrs.onchange(search_text)
                })
        )
    ]
}


const author_table = {

    view: vnode => {
        let filtered_list = vnode.attrs.authors

        if (filtered_list.length == 0 && Authors.loaded) {
            return m(no_results, { filter_active_warning: vnode.attrs.filter_active_warning })
        }
        return [
            m('.separate_top'),
            m('a.button_link.align_centre.p-10.d_block.column_adjuster',
                {
                    onclick: () => {
                        vnode.state.adjusting_columns = true
                    }
                },
                'Add/Remove Columns'
            ),
            m(my_table,

                {
                    rows: filtered_list,
                    columns: vnode.attrs.columns.filter(c => vnode.attrs.enabled_columns.some(e => e == c.code)),
                    skeleton_rows: !Authors.loaded,
                }
            ),

            vnode.state.adjusting_columns ?
                m(column_adjuster, {
                    all_columns: vnode.attrs.columns,
                    enabled_columns: vnode.attrs.enabled_columns,
                    change_columns: vnode.attrs.change_columns,
                    apply: () => { vnode.state.adjusting_columns = false },
                    reset: () => vnode.attrs.change_columns(vnode.attrs.default_enabled_columns)
                }
                ) :
                []
        ]
    }
}


const all_author_columns = [
    {
        header: { view: vnode => m('', 'Pen Name') },
        code: 'pen_name',
        title: 'Pen Name',
        content: {
            view: vnode => m('a.my_link',
                {
                    href: '/author/' + vnode.attrs.row.code,
                },
                vnode.attrs.row.pen_name)
        },
        order: (a, b, empty_first) => alphabetise(a.pen_name, b.pen_name, { empty_first: empty_first }),

    },
    {
        header: { view: vnode => m('', 'Full Name') },
        code: 'full_name',
        title: 'Full Name',
        content: {
            view: vnode => (
                vnode.attrs.row.full_name && vnode.attrs.row.full_name != vnode.attrs.row.pen_name ?
                    vnode.attrs.row.full_name :
                    vnode.attrs.row.pen_name

            )
        },
        order: (a, b) => alphabetise(a.full_name || a.pen_name, b.full_name || b.pen_name),
    },
    {
        header: { view: vnode => m('', 'Genres') },
        code: 'genres',
        content: { view: vnode => (Authors.get_author_main_genres({ author: vnode.attrs.row })).map(g => capitalise_first(g)).join(', ') },
        order: (a, b) => alphabetise(a.genres[0], b.genres[0]),
    },
    {
        header: { view: vnode => m('', 'Country') },
        code: 'nationality',
        title: 'Nationality',
        content: { view: vnode => vnode.attrs.row.nationality },
        order: (a, b, empty_first) => alphabetise(a.nationality, b.nationality, { empty_first: empty_first }),
    },
    {
        header: { view: vnode => m('', 'Y. of Birth') },
        code: 'born',
        title: 'Y. Of Birth',
        content: { view: vnode => vnode.attrs.row.born?.year },
        order: (a, b, empty_first) => num_compare(a.born?.year, b.born?.year, { empty_first: empty_first }),
    },
    {
        header: { view: vnode => m('', 'Y. of Death') },
        code: 'died',
        title: 'Y. Of Death',
        content: { view: vnode => vnode.attrs.row.died?.year },
        order: (a, b, empty_first) => num_compare(a.died?.year, b.died?.year, { empty_first: empty_first }),
    },
    {
        header: { view: vnode => 'Websites' },
        code: 'websites',
        content: { view: vnode => m('.d_flex.flex_wrap.flex_gap', vnode.attrs.row.websites?.map(site => m('a.external_link', { href: site.link, target: '_blank' }, site.title))) },
        order: (a, b, empty_first) => num_compare(a.websites?.length, b.websites?.length, { empty_first: empty_first }
        ),
    },
    {
        header: { view: vnode => m('.', 'Total Stories') },
        code: 'n_works',
        title: 'Total Stories',
        content: { view: vnode => vnode.attrs.row.works?.length },
        order: (a, b, empty_first) => -num_compare(a.works?.length, b.works?.length, { empty_first: empty_first }
        ),
    },
    {
        header: { view: vnode => m('.', 'Ranking') },
        code: 'l_ranking',
        title: 'Ranking',
        content: {
            view: vnode => `${vnode.attrs.row.rating} points`
        },
        order: (a, b, empty_first) => -num_compare(
            a.rating,
            b.rating,
            { empty_first: empty_first }
        ),
    }
]


const no_results = {
    view: vnode => {
        return [
            m('.separate_top'),
            m('b.no_results', 'No results found', vnode.attrs.filter_active_warning ? [' - ', m('span.warning', 'Filters Are Active')] : []),
            m('.email_me_no_results.align_centre',
                m('a.my_link', {
                    href: 'mailto:eclauthor@gmail.com'
                },
                    'Email me'),
                ' about the author you are looking for and I will do my best to add them to the library.'
            ),
        ]
    }
}


const Genres_options = {
    view: vnode => {

        let all_genres = Genres.list.map(g => g.code).sort().map(g => capitalise_first(g))

        return [
            m(popup,
                {
                    class: 'dynamic_popup',
                    on_click_outside: () => {
                        vnode.attrs.apply()
                    }
                },

                m('.options_header', 'Filter by Genres'),

                m('.search_bar',
                    m(my_input,

                        {
                            value: vnode.state.search,
                            search: true,
                            class: 'absolute_centre',
                            placeholder: 'Search',
                            onfocus: () => { },
                            onchange: (search_text) => vnode.state.search = search_text
                        })
                ),

                m('.options_grid',
                    {
                        class: vnode.attrs.strategy ? 'options_grid_squished' : ''
                    },
                    //Genres

                    all_genres.sort((a, b) => {

                        let selected_a = vnode.attrs.selected_genres.includes(a)
                        let selected_b = vnode.attrs.selected_genres.includes(b)

                        if (selected_a && !selected_b) return -1
                        else if (!selected_a && selected_b) return 1
                        else if (a > b) return 1
                        else if (b > a) return -1
                        return 0
                    })
                        .map((genre, n) => {
                            let genre_is_selected = vnode.attrs.selected_genres.includes(genre)

                            return [
                                (!vnode.state.search || (vnode.state.search && genre.toUpperCase().includes(vnode.state.search.toUpperCase())))

                                    ? m('button.filter_option',
                                        {
                                            class: 'genre ' + (genre_is_selected ? 'active' : ''),
                                            onclick: () => {
                                                vnode.attrs.onclick(genre)
                                                vnode.state.search = ''
                                            }
                                        },
                                        genre_is_selected ? m(tick_icon) : [],

                                        (vnode.state.search && genre.toUpperCase().includes(vnode.state.search.toUpperCase())) ?
                                            m('b', genre) :

                                            genre
                                    ) : []

                            ]
                        }
                        ),

                    !all_genres.filter(genre =>
                        !vnode.state.search ||
                        genre.toUpperCase().includes(vnode.state.search.toUpperCase())
                    ).length ?
                        ('.filter_option',
                        {
                            class: 'genres',
                        },

                            m('b', 'No results')
                        ) : []
                ),

                vnode.attrs.strategy ? m('.filter_strategy_buttons',
                    [
                        { code: 'Any', title: 'Match with any selected genre' },
                        { code: 'Primary', title: 'Match primary genre with any selected genre' },
                        { code: 'All', title: 'Match with all selected genres' }
                    ].map(strategy => {
                        return [
                            m('button.filter_strategy_button',
                                {
                                    class: strategy.code == vnode.attrs.strategy ? 'active' : '',
                                    onclick: () => {
                                        vnode.attrs.change_strategy(strategy.code)
                                    },
                                    title: strategy.title
                                },
                                strategy.code,
                            ),

                        ]
                    })
                ) : [],

                m('.filter_option_save_buttons',

                    m('button.filter_button.dark_link',
                        {
                            onclick: () => { vnode.attrs.clear() }
                        },
                        m('.text', 'Clear All')
                    ),

                    m('button.filter_button.dark_link',
                        {
                            onclick: () => { vnode.attrs.select_all() }
                        },
                        m('.text', 'Select All')
                    ),

                    m('button.filter_button.cancel_link.right_filter_button',
                        {
                            onclick: () => { vnode.attrs.close() }
                        },
                        m('.text', 'Cancel')
                    ),

                    m('button.filter_button.my_link.left_filter_button',
                        {
                            onclick: () => { vnode.attrs.apply() }
                        },
                        m('.text', 'Apply')
                    ),
                )
            )
        ]
    }
}

const Decades_options = {
    view: vnode => {


        let all_decades = []

        for (let dec = vnode.attrs.earlist_decade; dec <= vnode.attrs.latest_decade; dec += 10) {
            all_decades.push(dec)
        }


        return m(popup,
            {
                class: 'dynamic_popup',
                on_click_outside: () => {
                    vnode.attrs.apply()
                }

            },

            m('.options_header', 'Filter by Decade'),

            m('.length_slider_block',
                m(range_slider,
                    {
                        flash: vnode.state.flash,
                        min: vnode.attrs.decade_range?.start,
                        max: vnode.attrs.decade_range?.end,
                        change_min: (x) => {
                            vnode.attrs.change_min_decade(x);
                        },
                        change_max: (x) => {
                            vnode.attrs.change_max_decade(x);
                        },
                    }
                )
            ),

            m('.header_text.align_centre.m-10',
                '' + (Math.floor((vnode.attrs.earlist_decade + (vnode.attrs.decade_range?.start / 100) * (vnode.attrs.latest_decade - vnode.attrs.earlist_decade)) / 10) * 10) + ' - ' +
                '' + ((Math.ceil((vnode.attrs.earlist_decade + (vnode.attrs.decade_range?.end / 100) * (vnode.attrs.latest_decade - vnode.attrs.earlist_decade)) / 10) * 10))
            ),

            m('.options_grid',
                [
                    { title: '20th Century', start: 100 * (1900 - vnode.attrs.earlist_decade) / (vnode.attrs.latest_decade - vnode.attrs.earlist_decade), end: 100 * (2000 - vnode.attrs.earlist_decade) / (vnode.attrs.latest_decade - vnode.attrs.earlist_decade) },
                    { title: '19th Century', start: 100 * (1800 - vnode.attrs.earlist_decade) / (vnode.attrs.latest_decade - vnode.attrs.earlist_decade), end: 100 * (1900 - vnode.attrs.earlist_decade) / (vnode.attrs.latest_decade - vnode.attrs.earlist_decade) },
                ].map((option, n) =>
                    m('button.filter_option',
                        {
                            onclick: () => {
                                vnode.attrs.set({ start: option.start, end: option.end });
                            }
                        },
                        option.title,
                    )
                )
            ),
            m('.filter_option_save_buttons',

                m('button.filter_button.wide_filter_button.dark_link',
                    {
                        onclick: () => { vnode.attrs.clear() }
                    },
                    m('.text', 'Clear')
                ),

                m('button.filter_button.cancel_link.right_filter_button',
                    {
                        onclick: () => { vnode.attrs.close() }
                    },
                    m('.text', 'Cancel')
                ),

                m('button.filter_button.my_link.left_filter_button',
                    {
                        onclick: () => { vnode.attrs.apply() }
                    },
                    m('.text', 'Apply')
                ),
            )
        )
    }
}

const Large_tiles = {

    oninit: vnode => {
        // vnode.state.sort_method = (a, b) => sorter.alphabetise(a.pen_name, b.pen_name)
        // vnode.state.sort_code = 'pen_name'

    },

    view: vnode => {
        if (vnode.attrs.authors.length == 0 && Authors.loaded) {
            return m(no_results, { filter_active_warning: vnode.attrs.filter_active_warning })
        }
        return [
            m('.separate_top'),

            m('.author_tiles_background',
                m('.author_rows.author_tiles',
                    {
                        class: `${vnode.attrs.icons ? 'icons' : ''}`
                    },

                    (vnode.attrs.authors.length ?
                        vnode.attrs.authors :
                        (
                            [...Array(10)].map(_ => ({ skeleton: true }))
                        )
                    )

                        .map(author => {
                            return [
                                m(author_tile, {
                                    author: author,
                                    restricted: vnode.attrs.icons,
                                    inspect: () => {
                                        vnode.state.inspecting = author.code
                                    }

                                })
                            ]
                        })
                )
            ),

            vnode.state.inspecting ? [
                m(popup,
                    {
                        class: 'dynamic_popup_2',
                        on_click_outside: () => {
                            vnode.state.inspecting = false
                        }
                    },


                    m('button.close_inspection', {
                        onclick: () => vnode.state.inspecting = false
                    }, 'Close'),


                    m(author_tile, {
                        author: vnode.attrs.authors.find(author => author.code == vnode.state.inspecting),
                        n: -1,
                        inspecting: true
                    }),
                ),


            ] : []
        ]
    }
}


const repopulate = vnode => {

    let min_year = Math.floor((vnode.state.earlist_decade + (vnode.state.decade_range?.start / 100) * (vnode.state.latest_decade - vnode.state.earlist_decade)) / 10) * 10
    let max_year = Math.ceil((vnode.state.earlist_decade + (vnode.state.decade_range?.end / 100) * (vnode.state.latest_decade - vnode.state.earlist_decade)) / 10) * 10

    const { selected_genres, genre_strategy } = vnode.state


    vnode.state.filtered_authors = Authors.list.filter(author =>

        //Search Check
        ((
            !vnode.state.searching_text) ||
            (author.pen_name.toUpperCase()).includes(vnode.state.searching_text.toUpperCase()) ||
            ((author.full_name || '').toUpperCase()).includes(vnode.state.searching_text.toUpperCase())) &&

        //Filter check
        (
            vnode.state.selected_genres.length == 0 ||
            (
                //                vnode.state.selected_genres.some(g => (Authors.get_author_main_genres({ author: author })).includes(g.toLowerCase()))
                (genre_strategy == 'Any' && selected_genres.some(g => Authors.get_author_main_genres({ author: author }).includes(g.toLowerCase()))) ||
                (genre_strategy == 'Primary' && selected_genres.some(g => Authors.get_author_main_genres({ author: author })[0] == (g.toLowerCase()))) ||
                (genre_strategy == 'All' && selected_genres.every(g => Authors.get_author_main_genres({ author: author }).includes(g.toLowerCase())))

            )
        ) &&

        (
            (vnode.state.decade_range.start == 0 || (author.died?.year && author.died?.year > min_year)) &&
            (vnode.state.decade_range.end == 100 || (author.born?.year && author.born?.year < max_year))
        )
    )
}

const filter_button = {
    view: vnode => {
        return [
            m('button.open_filter_button',
                {
                    onclick: vnode.attrs.onclick,
                    class: vnode.attrs.active ? 'active' : ''
                },
                m(filter_icon),
                'Filter'
            )
        ]
    }
}

const sort_button = {
    view: vnode => {
        return [
            m('.sort_by',
                m('.sort_by_button_wrapper',
                    m('select.sort_by_button',
                        {
                            value: vnode.attrs.sort_code,
                            onchange: vnode.attrs.onchange
                        },

                        vnode.attrs.columns
                            .filter(c => ['pen_name', 'full_name', 'nationality', 'born', 'died', 'n_works', 'l_ranking'].includes(c.code))

                            .map(c => m('option', { value: c.code }, c.title)),
                        // 'Sort By:',
                        // m('b', 'Title')
                    )
                ),

                m('button.button_link.reverse_sort_button', {
                    onclick: vnode.attrs.reverse,
                    title: vnode.attrs.sorting_reversed ? 'Ascending' : 'Descending'
                },
                    vnode.attrs.sorting_reversed ? m(up_arrow, { fill: 'currentColor' }) : m(down_arrow, { fill: 'currentColor' }),
                    // vnode.attrs.sorting_reversed ? 'Ascending' : 'Descending'

                )
            )
        ]
    }
}

const display_buttons = {
    view: vnode => {
        return [
            m('.display_buttons',
                m('button.display_button',
                    {
                        class: vnode.attrs.display == 'tiles' ? 'active' : '',
                        onclick: () => { vnode.attrs.onchange('tiles') },
                        title: 'Cards'

                    },
                    m('.di_computer', 'Cards'),
                    m(tile_icon)
                ),
                m('button.display_button',
                    {
                        class: vnode.attrs.display == 'icons' ? 'active' : '',
                        onclick: () => { vnode.attrs.onchange('icons') },
                        title: 'Tiles'

                    },
                    m('.di_computer', 'Tiles'),
                    m(icons_icon)
                ),
                m('button.display_button',
                    {
                        class: vnode.attrs.display == 'list' ? 'active' : '',
                        onclick: () => { vnode.attrs.onchange('list') },
                        title: 'List'
                    },
                    m('.di_computer', 'List'),
                    m(list_icon)
                )
            )
        ]
    }
}


const filter_selection = {
    oninit: vnode => {
    },
    view: vnode => {
        return [
            m(popup,
                {
                    class: 'dynamic_popup',
                    on_click_outside: () => {
                        vnode.attrs.close()
                    }

                },

                m('.align_centre.filter_header', 'Filters'),

                m('.centre.d_flex.flex_gap.flex_wrap.d_centre',
                    m('button.filter_select_button.button_link',
                        {
                            oncreate: vnode => vnode.dom.focus(),
                            onclick: () => {
                                vnode.attrs.close()
                                vnode.attrs.open_filter('Genres')
                            },
                            class: vnode.attrs.selected_genres.length ? 'active' : ''
                        },
                        m('.filter_select_title',
                            'Genres'
                        ),

                        m(filter_icon)),

                    m('button.filter_select_button.button_link',
                        {
                            onclick: () => {
                                vnode.attrs.close()
                                vnode.attrs.open_filter('Decades')
                            },
                            class: (vnode.attrs.decade_range.start != 0 || vnode.attrs.decade_range.end != 100) ? 'active' : ''

                        },
                        m('.filter_select_title',
                            'Decades'
                        ),

                        m(filter_icon)
                    ),
                ),
                m('.filter_option_save_buttons',

                    m('button.filter_button.dark_link', {
                        onclick: () => vnode.attrs.reset()
                    },
                        'Clear All'
                    ),
                    m('button.filter_button.my_link', {
                        onclick: () => vnode.attrs.close()
                    },
                        'Close'
                    )
                )
            )
        ]
    }
}

const update_search = (vnode, new_text) => {
    if (vnode.state.search_delay) clearTimeout(vnode.state.search_delay)
    vnode.state.search_delay = setTimeout(() => {
        repopulate(vnode)
        redraw()
    }, SEARCH_FILTER_DELAY);
}




let load_authors = vnode => {
    Authors.load(() => {
        let earlist_decade
        let latest_decade

        Authors.list.forEach(author => {
            if (!earlist_decade || earlist_decade > author.born?.year) {
                earlist_decade = author.born?.year
            }
            if (!latest_decade || latest_decade < author.died?.year) {
                latest_decade = author.died?.year
            }
        })

        // return []
        vnode.state.earlist_decade = Math.floor(earlist_decade / 10) * 10
        vnode.state.latest_decade = Math.ceil(latest_decade / 10) * 10
        repopulate(vnode)
        redraw()
    })
}




// Remove filter/hue change
// Move shade to title




export default Page